import React from 'react'
import { StripeBG, Link, Icon} from '../components/'
import { Navbar, Footer} from '../components/marketing'
import {seoPageChange} from '../utils'

class Home extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {seoPageChange()}

  render() {
    return (
      <div className="HomePage">
        <StripeBG bg2={"white"} />
        <Navbar className="grid-restrain"/>
        <div className="top-desc grid-row grid-column grid-restrain v-align h-align s30 full-7 full-s20">
          <h1>Spend less time on browser tests.</h1>
          <h2>SnapTest is a browser extension for fast, light-weight, and scalable browser tests & macros.</h2>
        </div>
        <div className="grid-row grid-restrain s10 full-7 full-s20">
          <div className="grid-item-3 sr4 full-s10 full-s7">
            <div className="grid-item-4 video-cont full-s10">
              <div className="videoWrapper">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/TrcuJxZIe38??theme=light&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0&amp;controls=0" frameBorder="0" allowFullScreen=""></iframe>
              </div>
            </div>
          </div>
          <div className="grid-item-2 grid-row grid-column v-align h-align">
            <a className="cta-primary s2" href="https://chrome.google.com/webstore/detail/snaptest/aeofjocnhdlleichkjbaibdbicpcddhp" target="_blank">+ Get the chrome extension</a>
            <button className="cta-secondary"
                    onClick={() => window.open("https://www.reddit.com/r/programming/comments/6mgvgq/made_a_selenium_idelike_chrome_extension_that_can/?st=jfn3oh5w&sh=5235ba44")}>+ What does Reddit think of SnapTest?</button>
            <div className="cute-link">
              <Link to={"/updates"}>We are making progress fast. Check it out.</Link>
            </div>
          </div>
        </div>
        <section className="product-hero grid-restrain grid-row v-align h-align full-10">
          <div>
            <h1 className="s6 grid-row h-align">Lightweight & Scalable!</h1>
            <div className="description s6">
              <ul>
                <li>Create and maintain your tests quickly with the best test recorder around.</li>
                <li>Scale using components, variables, environments, run configurations, tags, and more...</li>
                <li>Fits any team size - team collaboration features.</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="snapshots text-center">
          <div className="grid-restrain grid-row grid-column full-8">
            <div className="grid-row full-8">
              <div className="grid-item">
                <a href="https://res.cloudinary.com/snaptest/image/upload/v1530677595/marketing/Screen_Shot_2018-07-03_at_11.13.05_PM.png" target="_blank">
                  <img className="snapshot card" src="https://res.cloudinary.com/snaptest/image/upload/v1530677595/marketing/Screen_Shot_2018-07-03_at_11.13.05_PM.png" />
                </a>
              </div>
              <div className="grid-item">
                <a href="https://res.cloudinary.com/snaptest/image/upload/v1530677871/marketing/Screen_Shot_2018-07-03_at_11.17.26_PM.png" target="_blank">
                  <img className="snapshot card" src="https://res.cloudinary.com/snaptest/image/upload/v1530677871/marketing/Screen_Shot_2018-07-03_at_11.17.26_PM.png" />
                </a>
              </div>
            </div>
            <div className="grid-row full-8">
              <div className="grid-item">
                <a href="https://res.cloudinary.com/snaptest/image/upload/v1530679015/marketing/Screen_Shot_2018-07-03_at_11.36.35_PM.png" target="_blank">
                  <img className="snapshot card" src="https://res.cloudinary.com/snaptest/image/upload/v1530679015/marketing/Screen_Shot_2018-07-03_at_11.36.35_PM.png" />
                </a>
              </div>
              <div className="grid-item">
                <a href="https://res.cloudinary.com/snaptest/image/upload/v1530679075/marketing/generate.png" target="_blank">
                  <img className="snapshot card" src="https://res.cloudinary.com/snaptest/image/upload/v1530679075/marketing/generate.png" />
                </a>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/index.js